import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'smartDate' })
export class SmartDatePipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');
  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    let d: Date;
    if (typeof value === 'string') {
      // Detect ISO date-only strings (YYYY-MM-DD) and create a local Date
      const isoDateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoDateOnly) {
        const y = Number(isoDateOnly[1]);
        const m = Number(isoDateOnly[2]);
        const day = Number(isoDateOnly[3]);
        d = new Date(y, m - 1, day); // construct as local date (no timezone shift)
      } else {
        d = new Date(value);
      }
    } else {
      d = new Date(value);
    }
    if (isNaN(d.getTime())) return String(value);
    const hasTime = d.getHours() !== 0 || d.getMinutes() !== 0 || d.getSeconds() !== 0;
    const fmt = hasTime ? 'HH:mm dd-MM-yyyy' : 'dd-MM-yyyy';
    return this.datePipe.transform(d, fmt) ?? '';
  }
}
